export var LengthType;
(function (LengthType) {
    LengthType["VAR_BINARY"] = "VAR_BINARY";
    LengthType["GEOMETRIES"] = "GEOMETRIES";
    LengthType["PARTS"] = "PARTS";
    LengthType["RINGS"] = "RINGS";
    LengthType["TRIANGLES"] = "TRIANGLES";
    LengthType["SYMBOL"] = "SYMBOL";
    LengthType["DICTIONARY"] = "DICTIONARY";
})(LengthType || (LengthType = {}));
//# sourceMappingURL=lengthType.js.map